export const loadVideoToFile = async (url: string): Promise<File> => {
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Failed to fetch video: ${response.status} ${response.statusText}`);
    }

    const blob = await response.blob();
    const filename = new URL(url).pathname.split("/").pop() || "video.mp4";

    return new File([blob], filename, { type: blob.type });
  } catch (error) {
    console.error("Error loading video to file:", error);
    throw error;
  }
};
